// extracted by mini-css-extract-plugin
export default {"main":"FilterByNumber_main__c0Vp-"};